import LandingView from './components/LandingView'
import ResultsView from './components/ResultsView'
import ProtocolView from './components/ProtocolView'

export const routes = [
  { path: '/', name: 'home', component: LandingView },
  { path: '/categories/:category/:subCategory?', name: 'category-query', component: ResultsView },
  { path: '/search/', name: 'search-query', component: ResultsView },
  { path: '/protocol/:slug', name: 'protocol', component: ProtocolView }
]



// WEBPACK FOOTER //
// ./src/routes.js